<template>
  <div class="entering-wrapper">
    <template v-if="dataDone && isDoctor">
      <entering-step :step="step" stepOneText="个人信息" stepTwoText="认证信息" />
      <!-- 第一部分 -->
      <div class="form-wrapper">
        <!-- 头像 -->
        <div class="form-item click avatar" @click="wxAvatarUpload()" id="avatarUploader">
          <div class="form-type">
            <span class="required">上传头像</span>
            <p class="tips">建议上传身着白大褂的正面像</p>
          </div>
          <div class="form-content">
            <div class="avatar-box" id="uploadAvatar">
              <img src="@/assets/images/upload-avatar-default.png" v-if="!uploadPreview">
              <img :src="uploadPreview" v-else>
            </div>
          </div>
        </div>
        <!-- 真实姓名 -->
        <div class="form-item click" :class="{'error': realNameError}">
          <div class="form-type"><span class="required">真实姓名</span></div>
          <div class="form-content">
            <input type="text" class="form-text" v-ios-bug-fixed placeholder="请输入姓名" v-model="realName">
          </div>
          <div class="form-error" v-if="realNameError">
            <van-icon name="fail" />{{realNameErrorMsg}}</div>
        </div>
        <!-- 性别 -->
        <div class="form-item click" :class="{'error': genderError}" @click="genderPickerShow = true">
          <div class="form-type"><span class="required">性别</span></div>
          <div class="form-content">
            <div class="picker-tips" v-if="!gender">请选择
              <icon icon-class="arrow" />
            </div>
            <div class="picker-value" v-else>{{this.gender | sexFilter}}</div>
          </div>
          <div class="form-error" v-if="genderError">
            <van-icon name="fail" />{{genderErrorMsg}}</div>
        </div>
        <!-- 身份证号 -->
        <div class="form-item click" :class="{'error': IDNumberError}">
          <div class="form-type"><span class="required">身份证号</span></div>
          <div class="form-content">
            <input type="text" class="form-text" v-ios-bug-fixed placeholder="请输入" v-model="IDNumber">
          </div>
          <div class="form-error" v-if="IDNumberError">
            <van-icon name="fail" />{{IDNumberErrorMsg}}</div>
        </div>
        <!-- 执业医疗机构 -->
        <div class="form-item click">
          <div class="form-type"><span class="required">执业医疗机构</span></div>
          <div class="form-content">
            <input type="text" class="form-text" v-ios-bug-fixed placeholder="请输入医疗机构名称" v-model="organization">
          </div>
        </div>
        <!-- 科室 -->
        <div class="form-item click" @click="getDepartmentData">
          <div class="form-type"><span class="required">科室</span></div>
          <div class="form-content">
            <div class="picker-tips" v-if="!departmentShowText">请选择
              <icon icon-class="arrow" />
            </div>
            <div class="picker-value" v-else>{{departmentMainText}} - {{departmentShowText}}</div>
          </div>
        </div>
        <!-- 职称 -->
        <div class="form-item click" @click="jobTitlePickerShow = true">
          <div class="form-type"><span class="required">职称</span></div>
          <div class="form-content">
            <div class="picker-tips" v-if="!jobTitle">请选择
              <icon icon-class="arrow" />
            </div>
            <div class="picker-value" v-else>{{jobTitle | jobTitleFilter}}</div>
          </div>
        </div>
        <!-- 所在地 -->
        <div class="form-item click" @click="areaPickerShow = true">
          <div class="form-type"><span>所在地</span></div>
          <div class="form-content">
            <div class="picker-tips" v-if="!location.province">请选择
              <icon icon-class="arrow" />
            </div>
            <div class="picker-value" v-else>{{location.province + location.city}}</div>
          </div>
        </div>
      </div>
      <!-- 第二部分 -->
      <div class="form-wrapper">
        <div class="form-item vertical" :class="{'error': expError}">
          <div class="form-type"><span class="required">执业经历</span></div>
          <div class="form-content">
            <textarea class="form-textarea" v-ios-bug-fixed placeholder="医生简介" v-model="exp" maxlength="600"></textarea>
            <span class="textarea-limit">{{exp.length}}/600</span>
          </div>
          <div class="form-error" v-if="expError">
            <van-icon name="fail" />{{expErrorMsg}}</div>
        </div>
        <div class="form-item vertical">
          <div class="form-type"><span>专业擅长</span></div>
          <div class="form-content">
            <textarea class="form-textarea" v-ios-bug-fixed placeholder="擅长的领域" v-model="speciality" maxlength="300"></textarea>
            <span class="textarea-limit">{{speciality.length}}/300</span>
          </div>
        </div>
      </div>
      <!-- 第三部分 -->
      <div class="form-wrapper">
        <div class="form-item" :class="{'error': phoneError}">
          <div class="form-type"><span class="required">手机号</span></div>
          <div class="form-content">
            <input type="text" class="form-text" placeholder="请输入" v-model="phone" :disabled="bindedPhone">
          </div>
          <div class="form-error" v-if="phoneError">
            <van-icon name="fail" />{{phoneErrorMsg}}</div>
        </div>
        <div class="form-item" v-if="!bindedPhone">
          <div class="code-input-box"><input type="number" class="code-input" v-model="code" @input="codeChange"
              placeholder="请输入验证码"></div>
          <div class="form-content">
            <button class="get-code-button" @click="countdown" :disabled="sandingCode">
              <span v-if="sandingCode">已发送 {{time}}s</span>
              <span v-else>获取验证码</span>
            </button>
          </div>
        </div>
      </div>
      <div class="submit-box"><button class="submit-button" :disabled="submitting" @click="nextStep">下一步</button></div>

      <!-- 弹出层 -->
      <!-- 性别选择 -->
      <van-popup v-model="genderPickerShow" position="bottom">
        <van-picker show-toolbar :columns="genderData" value-key="label" @cancel="genderPickerShow = false" @confirm="confirmGender" />
      </van-popup>
      <!-- 所在地选择 -->
      <van-popup v-model="areaPickerShow" position="bottom">
        <van-area :area-list="areaList" :columns-num="2" title="所在地区" @cancel="areaPickerShow = false" @confirm="confirmLocation" />
      </van-popup>
      <!-- 科室选择 -->
      <van-popup v-model="departmentPickerShow" position="bottom" title="选择科室" class="department-selector">
        <van-tree-select :items="departmentData" :main-active-index="departmentMainActiveIndex" :active-id="departmentActiveId"
          @navclick="navClick" @itemclick="itemClick" />
      </van-popup>
      <!-- 职称选择 -->
      <van-popup v-model="jobTitlePickerShow" position="bottom">
        <van-picker show-toolbar :columns="jobTitleData" value-key="label" @cancel="jobTitlePickerShow = false"
          @confirm="confirmJobTitle" />
      </van-popup>
    </template>
    <div v-if="dataDone && !isDoctor" class="doctor-error">您是患者，不能进行绑定医生操作</div>
  </div>

</template>

<style lang="less" scoped>
  .doctor-error{
    min-height: 100vh;
    padding: 50px 0;
    font-size: 18px;
    font-weight: bold;
    color: #666;
    text-align: center;
  }
  .entering-wrapper{
    background: #F7F7F7;
  }
  .form-wrapper{
    padding: 24px 0 12px;
    margin-top: 12px;
    background: #FFF;
    .upload-avatar-box{
      width: 100%;
      .van-uploader__input-wrapper{
        width: 100%;
      }
    }
    .form-item{
      position: relative;
      padding: 0 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #FFF;
      height: 40px;
      margin-bottom: 16px;
      transition: all .1s;
      &.vertical{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        height: auto;
        .form-content{
          position: relative;
          width: 100%;
          margin-top: 16px;
          .form-textarea{
            border: 1px solid #F7F7F7;
            background: #F7F7F7;
            resize: none;
            padding: 12px;
            font-size: 14px;
            line-height: 20px;
            color: #666;
            width: 100%;
            height: 144px;
            &::-webkit-input-placeholder{
              color: #999;
            }
          }
          .textarea-limit{
            position: absolute;
            right: 8px;
            bottom: 8px;
            font-size: 12px;
            color: #999;
          }
        }
      }
      &.avatar{
        height: 80px;
        margin-bottom: 12px;
      }
      &.click{
        cursor: pointer;
        &:active{
          background: #F9F9F9;
        }
      }
      &.error{
        margin-bottom: 28px;
        .form-content .form-text{
          color: @error;
        }
      }
      .form-type{
        font-size: 16px;
        color: #666;
        font-weight: bold;
        .required{
          position: relative;
          &::after{
            content: '*';
            position: absolute;
            left: 100%;
            top: 0;
            margin-left: 2px;
            font-size: 16px;
            color: @error;
          }
        }
        .tips{
          margin-top: 6px;
          font-size: 12px;
          color: @xile;
        }
      }
      .form-content{
        color: #666;
        font-size: 16px;
        .avatar-box{
          width: 64px;
          height: 64px;
          overflow: hidden;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            width: 100%;
            // height: 100%;
          }
        }
        .form-text{
          width: 200px;
          border: 0;
          text-align: right;
          font-size: 16px;
          line-height: 40px;
          color: #666;
          background: transparent;
          &::-webkit-input-placeholder{
            color: #999;
          }
        }
        .picker-tips{
          font-size: 16px;
          color: #999;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          svg{
            position: relative;
            top: 2px;
            font-size: 14px;
            margin-left: 4px;
          }
        }
        .picker-value{
          max-width: 240px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .get-code-button{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 84px;
          height: 32px;
          border: 1px solid @xile;
          color: @xile;
          font-weight: bold;
          background: transparent;
          font-size: 12px;
          border-radius: 4px;
          transition: all .1s;
          &:disabled{
            border-color: #CCC;
            color: #CCC;
            &:active{
              opacity: 1;
            }
          }
          &:active{
            opacity: .8;
          }
        }
      }
      .code-input-box{
        .code-input{
          width: 200px;
          border: 0;
          font-size: 16px;
          line-height: 40px;
          color: #666;
          background: transparent;
          &::-webkit-input-placeholder{
            color: #999;
          }
        }
      }
      .form-error{
        position: absolute;
        right: 16px;
        top: 100%;
        font-size: 12px;
        color: @error;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .van-icon{
          position: relative;
          top: 1px;
          width: 12px;
          height: 12px;
          background: @error;
          color: #FFF;
          border-radius: 50%;
          margin-right: 4px;
        }
      }
    }
  }
  .submit-box{
    padding: 24px 16px 12px;
    .submit-button{
      @button-base();
      width: 100%;
      height: 40px;
      font-size: 14px;
    }
  }
</style>

<script type="text/javascript">
  import areaList from '@/untils/area'
  import enteringStep from '@/components/Common/enteringStep'
  export default {
    data() {
      return {
        is_new: 1,
        dataDone: false,
        isDoctor: true,
        // 头像上传实例
        avatarUploader: null,
        uploadPreview: null,
        avatar: '',
        step: 1,
        // 真实姓名
        realName: '',
        realNameError: false,
        realNameErrorMsg: '请输入真实姓名',
        // 性别
        gender: '',
        genderError: false,
        genderErrorMsg: '请选择性别',
        genderData: [{
            label: '男',
            value: 1
          },
          {
            label: '女',
            value: 2
          },
        ],
        genderPickerShow: false,
        // 身份证号
        IDNumber: '',
        IDNumberError: false,
        IDNumberErrorMsg: '请输入身份证号',
        // 所在地
        areaList,
        location: {
          province: '',
          city: ''
        },
        areaPickerShow: false,
        // 机构
        organization: '',
        // 科室
        department: '',
        departmentData: [],
        departmentPickerShow: false,
        departmentMainActiveIndex: 0,
        departmentMainText: '',
        departmentActiveId: null,
        departmentShowText: '',
        // 职称
        jobTitle: '',
        jobTitleData: [{
            label: '医师',
            value: 1
          },
          {
            label: '住院医师',
            value: 2
          },
          {
            label: '主任医师',
            value: 3
          },
          {
            label: '副主任医师',
            value: 4
          },
          {
            label: '主治医师',
            value: 5
          },
          {
            label: '医士',
            value: 6
          },
          {
            label: '药士',
            value: 7
          },
          {
            label: '药师',
            value: 8
          },
          {
            label: '主管药师',
            value: 9
          },
          {
            label: '副主任药师',
            value: 10
          },
          {
            label: '主任药师',
            value: 11
          },
        ],
        jobTitlePickerShow: false,
        // 医生经历
        exp: '',
        expError: false,
        expErrorMsg: '请输入执业经历',
        // 擅长
        speciality: '',
        // 手机号
        phone: '',
        phoneError: false,
        phoneErrorMsg: '请输入手机号',
        // 绑定过手机号只显示不能修改
        bindedPhone: false,
        // 验证码
        code: '',
        codeError: false,
        codeErrorMsg: '请输入验证码',
        // 倒计时
        countDownTimer: null,
        time: 60,
        sandingCode: false,

        submitting: false,
      }
    },
    created() {
      let _this = this;
      let url = encodeURIComponent(window.location.href.split('#')[0])
      this.$root.post('/getJsSdk', {
        // url: `${window.location.protocol}//${window.location.host}/`
        url: url
      }).then(data => {
        if (data) {
          wx.config({
            debug: this.$store.state.wechatDebug,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ['chooseImage', 'uploadImage']
          });
          wx.checkJsApi({
            jsApiList: ['chooseImage', 'uploadImage'],
            success: function(res) {
              console.log(res)

            }
          });
        }
      })
      // 如果是患者直接跳转至患者首页
      // if(this.userInfo.role == 2) {
      //   this.$router.replace('/patient');
      // }
      // 如果医生状态为审核中或者已通过则直接跳转至对应页面
       // this.$router.replace('/doctor/waitting');
      if (this.userInfo.doc_status == 2 || this.userInfo.doc_status == 3) {
        this.$router.replace('/doctor/waitting');
      } else if (this.userInfo.doc_status == 4) {

        let _this = this;
        // this.$root.IMInit(this.userInfo.token, {
        // connectSuccess() {
        if (parseFloat(_this.userInfo.doc_money) == 0) {
          _this.$router.replace('/doctor/first-config');
        } else {
          _this.$router.replace('/doctor');
        }
        // }
        //  });

      } else {
        // this.$root.getUploadSign();
        this.$root.post('/getDepartmentList').then(data => {
          this.departmentData = data;
          this.echoData();
        })
      }

    },
    beforeDestroy() {
      clearInterval(this.countDownTimer);
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    watch: {
      realName(val) {
        if ($.trim(val) == '') {
          this.realNameError = true
          this.realNameErrorMsg = '请输入真实姓名'
        } else if (!/^([\u4e00-\u9fa5·]{2,10})$/.test($.trim(val))) {
          this.realNameError = true
          this.realNameErrorMsg = '请输入正确的姓名'
        } else {
          this.realNameError = false
        }
      },
      IDNumber(val) {
        if ($.trim(val) == '') {
          this.IDNumberError = true
          this.IDNumberErrorMsg = '请输入身份证号'
        } else if (!/^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$/.test($.trim(val))) {
          this.IDNumberError = true
          this.IDNumberErrorMsg = '请输入正确的身份证号'
        } else {
          this.IDNumberError = false
        }
      },
      exp(val) {
        if ($.trim(val) == '') {
          this.expError = true
          this.expErrorMsg = '请输入医生简介'
        } else {
          this.expError = false
        }
      },
      phone(val) {
        if ($.trim(val) == '') {
          this.phoneError = true
          this.phoneErrorMsg = '请输入手机号'
        } else if (!/^1\d{10}$/.test($.trim(val))) {
          this.phoneError = true
          this.phoneErrorMsg = '请输入正确的手机号'
        } else {
          this.phoneError = false
        }
      }
    },
    components: {
      enteringStep
    },
    methods: {
      wxAvatarUpload() {
        let _this = this;
        var int = 0;
        var serverIdArr = new Array();
        var localIdArr = new Array();

        wx.chooseImage({
          count: 1, // 默认9
          sizeType: ['compressed'],
          sourceType: ['album', 'camera'],
          success: function(res) {
            var localIds = res.localIds;
            localIdArr = localIds;
            wx.uploadImage({
              localId: localIds[int].toString(),
              isShowProgressTips: 1,
              success: function(res) {
                var serverId = res.serverId;
                _this.$root.post('/getWxImg', {
                  id: serverId,
                  oss_dir: 'doctor',
                  type: 1
                }).then(data => {
                  if (data.status == 1) {
                    _this.avatar = data.url;
                    _this.uploadPreview = data.url;
                    _this.$notify({
                      background: '#00848A',
                      message: '头像上传成功'
                    });
                  } else {
                    _this.$notify('发送图片失败');
                  }
                })


              },
              fail(err) {
                console.log('error');
                _this.$toast.clear();
                _this.$notify(`上传图片报错${JSON.stringify(err)}`);
              }
            });
          }
        });

      },
      // 信息回显
      echoData() {
        this.$root.post('/getDoctorInfo', {
          user_id: this.userInfo.user_id,
          type: 1 //1:获取第一步回显数据；2:获取第二布回显数据
        }).then(data => {
          this.dataDone = true;
          if (data.status == 0) {
            this.isDoctor = false;
          } else {
            this.isDoctor = true;
            if (data.avatar) {
              this.uploadPreview = data.avatar;
              this.avatar = data.avatar;
            }
            if (data.username) this.realName = data.username;
            if (data.gender) this.gender = data.gender;
            if (data.id_number) this.IDNumber = data.id_number;
            if (data.work_unit) this.organization = data.work_unit;
            if (data.department_id) {
              this.department = data.department_id;
              this.departmentData.forEach((items, index) => {
                if (items.children) {
                  items.children.forEach(item => {
                    if (item.id == this.department) {
                      this.departmentActiveId = item.id;
                      this.departmentMainActiveIndex = index;
                      this.departmentMainText = items.text;
                      this.departmentShowText = item.text;
                    }
                  })
                }
              })
            }
            if (data.title) {
              this.jobTitle = data.title;
            }
            if (data.province && data.city) {
              this.location.province = data.province;
              this.location.city = data.city;
            }
            this.exp = data.description || '';
            this.speciality = data.adept || '';
            if (data.mobile) {
              this.phone = data.mobile;
              this.bindedPhone = true;
              this.is_new = 0;
            }
            // 初始化上传
            this.$nextTick(() => {
              // this.setUpload(this.avatarUploader, 'avatarUploader');
            })
          }
        })
      },
      // 上传单张函数
      setUpload(obj, id) {
        let _this = this;
        obj = new plupload.Uploader({
          runtimes: 'html5,flash,silverlight,html4',
          browse_button: id,
          flash_swf_url: '/view/index/template/src/assets/js/plupload/js/Moxie.swf',
          silverlight_xap_url: '/view/index/template/src/assets/js/plupload/js/Moxie.xap',
          url: 'http://oss.aliyuncs.com',
          // 不检测重复文件
          filters: {
            // mime_types: [
            //   {title: "image", extensions: "jpg,webp,png,bmp"}
            // ],
            // prevent_duplicates: true,
          },
          // 单文件上传
          multi_selection: false,
          // 压缩
          resize: {
            quality: 60,
            preserve_headers: false,
          },
          init: {
            FilesAdded(up, files) {
              console.log(files);
              files.forEach(item => {
                let fileName = item.name;
                _this.$root.previewUploadImage(item, (imgSrc) => {
                  _this.uploadPreview = imgSrc;
                })
              })
              _this.$root.setUploadParam(up, '', false);
            },
            // 上传前设置文件名
            BeforeUpload(up, file) {
              _this.$root.setUploadParam(up, file.name, true);
            },
            // 上传完成
            FileUploaded(up, file, info) {
              if (info.status == 200) {
                let res = JSON.parse(info.response);
                _this.avatar = res.path;
              }

              console.log(info);
            },
            Error(up, err) {
              console.log(err);
            }
          }
        })
        // 初始化上传
        obj.init();
      },
      // 上传头像
      previewImg(file, name) {
        $(`#${name.name}`).find('img').prop('src', file.content);
        console.log(file);
      },
      // 确认选择性别
      confirmGender(value) {
        this.gender = value.value;
        this.genderPickerShow = false;
      },
      // 确认选择所在地
      confirmLocation(value) {
        if (value) {
          this.location.province = value[0].name;
          this.location.city = value[1].name;
        }
        this.areaPickerShow = false;
      },
      // 点击选择科室
      getDepartmentData() {
        if (this.departmentData.length == 0) {
          // get data
        }
        this.departmentPickerShow = true;
      },
      // 点击科室一级
      navClick(index) {
        this.departmentMainActiveIndex = index;
        // this.departmentMainText = this.departmentData[index].text;
      },
      itemClick(data) {
        console.log(data);
        this.departmentActiveId = this.department = data.id;
        this.departmentShowText = data.text;
        this.departmentPickerShow = false;
        this.departmentData.forEach((items, index) => {
          if (items.children) {
            items.children.forEach(item => {
              if (item.id == data.id) {
                this.departmentMainText = items.text;
              }
            })
          }
        })
      },
      confirmJobTitle(value) {
        this.jobTitle = value.value;
        this.jobTitlePickerShow = false;
      },
      // 获取验证码 倒计时
      countdown() {
        if (this.phone == '' || this.phoneError) {
          this.$notify('请输入正确的手机号');
          return;
        };
        this.$root.post('/sendPhoneCode', {
          mobile: this.phone
        }).then(data => {
          console.log(data);
          if (data.status == 1) {
            countDownAction();
          } else {
            this.$notify(data.msg);
          }
        })
        let countDownAction = () => {
          this.time = 60;
          this.countDownTimer = null;
          this.sandingCode = true;
          let timeDown = () => {
            this.time -= 1;
            if (this.time <= 0) {
              clearInterval(this.countDownTimer);
              this.sandingCode = false;
            }
          }
          this.countDownTimer = setInterval(timeDown, 1000);
        }

      },
      codeChange(e) {
        if (this.code.length > 6) {
          this.code = this.code.slice(0, 6);
        }
      },
      nextStep() {
        // 表单验证
        if (!this.avatar) {
          this.$notify('请上传头像');
          return;
        }
        if (!this.realName || this.realNameError) {
          this.$notify(this.realNameErrorMsg);
          return;
        }
        if (!this.gender) {
          this.$notify('请选择性别');
          return;
        }
        if (!this.IDNumber || this.IDNumberError) {
          this.$notify(this.IDNumberErrorMsg);
          return;
        }
        if (!this.organization) {
          this.$notify('请输入执业医疗机构名称');
          return;
        }
        if (!this.department) {
          this.$notify('请选择科室');
          return;
        }
        if (!this.jobTitle) {
          this.$notify('请选择职称');
          return;
        }
        if (!this.exp) {
          this.$notify('请输入执业经历');
          return;
        }
        if (!this.phone || this.phoneError) {
          this.$notify(this.phoneErrorMsg);
          return;
        }
        if (!this.bindedPhone && !this.code) {
          this.$notify('请输入正确的验证码');
          return;
        }
        this.submitting = true;
        // 整合提交数据
        let postData = {
          user_id: this.userInfo.user_id,
          user_token: this.userInfo.user_token,
          role: 1,
          avatar: this.avatar,
          username: this.realName,
          gender: this.gender,
          id_number: this.IDNumber,
          province: this.location.province,
          city: this.location.city,
          work_unit: this.organization,
          department_id: this.department,
          title: this.jobTitle,
          description: this.exp,
          adept: this.speciality,
          mobile: this.phone,
          code: this.code,
          is_new: this.is_new
        }
        // 如果手机号为已绑定，则不发送验证码字段
        if (this.bindedPhone) {
          delete postData.code;
        }
        console.log(postData);
        console.log(this.userInfo);
        this.$root.post('/register', postData).then(data => {
          console.log(data);
          this.submitting = false;
          if (data.status == 1) {
            this.userInfo.user_id = data.user_id;
            store.set('userInfo', this.userInfo);
            this.$store.commit('setUserInfo', this.userInfo);
            console.log(this.userInfo);
            if (this.$route.query.invite_id) {
              this.$router.push({
                path: '/doctor/certification',
                query: {
                  invite_id: this.$route.query.invite_id
                }
              });
            } else {
              this.$router.push('/doctor/certification');
            }
          } else {
            this.$notify(data.msg);
          }
        })
      }
    },
    filters: {
      sexFilter(value) {
        if (value == 1) {
          return '男'
        } else if (value == 2) {
          return '女'
        } else {
          return ''
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/Entering/baseInfo.vue